import { type FC } from "react";
import { Phone } from "lucide-react";

import { SUPPORT_PHONE } from "@/shared/constants/constants";
import { cn } from "@/shared/utils/cn";

interface CallSupportLineProps {
  className?: string;
}

export const CallSupportLine: FC<CallSupportLineProps> = ({ className }) => {
  return (
    <p className={cn("flex items-center gap-2 text-sm text-secondary", className)}>
      <Phone className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>
        Not sure where to start? Call us at{" "}
        <a href={SUPPORT_PHONE.href} className="font-medium text-primary hover:underline">
          {SUPPORT_PHONE.display}
        </a>
      </span>
    </p>
  );
};
